import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {styles} from "./SummaryImageStyles";
const useStyles = makeStyles(styles);

const ExpiredCyclesImage = () => {
    const classes = useStyles();

    return (
        <Fragment>
            <div style={{textAlign: 'center', padding: '8px'}}>
                <img src={require('../../../assets/images/ExpiredCycles.svg')} alt={'alt'} style={{width: '54px'}} className={classes.image} />
            </div>
        </Fragment>
    )
}

export default ExpiredCyclesImage;
